var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.5,138s-58-95-201-114-169,59-198,86-79,22-156,74-76,110-54,166,98,105,188,112,136-35,209-34,135,31,193,8S733.5,228,652.5,138Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.5,138s-58-95-201-114-169,59-198,86-79,22-156,74-76,110-54,166,98,105,188,112,136-35,209-34,135,31,193,8S733.5,228,652.5,138Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-91"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.88,
    y: 179.79,
    width: 252,
    height: 34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 467.04,
    y: 179.79,
    width: 252,
    height: 34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.88,
    cy: 197.72,
    r: 6.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 671.05,
    cy: 197.72,
    r: 6.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 523.79,
    cy: 197.72,
    r: 6.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.97,
    cy: 197.72,
    r: 6.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.83,196.7v-3.54h-3.65v3.54a5,5,0,0,0-3.19,4.66v2.74h10v-2.74A5,5,0,0,0,618.83,196.7Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.58,196.7v-3.54h-3.65v3.54a5,5,0,0,0-3.19,4.66v2.74h10v-2.74A5,5,0,0,0,595.58,196.7Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.33,196.7v-3.54h-3.65v3.54a5,5,0,0,0-3.19,4.66v2.74h10v-2.74A5,5,0,0,0,572.33,196.7Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 546.59,
    y1: 184.49,
    x2: 546.59,
    y2: 204.55,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.52,
    y1: 184.49,
    x2: 645.52,
    y2: 204.55,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-91"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.88,
    cy: 127.27,
    r: 44.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.88,
    cy: 127.27,
    r: 39.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.88,
    cy: 127.27,
    r: 3.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.23,
    y1: 129.73,
    x2: 88.63,
    y2: 141.95,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.63,
    y1: 123.62,
    x2: 100.63,
    y2: 96.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.46,372.31c.07,0,.81-4.91.82-5.22.13-3.67-1.78-10.83-5.65-12.23a4.86,4.86,0,0,0-6.28,3.6c-.7,2.82.9,6,2.62,8.15C125,369.12,131.46,372.31,131.46,372.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.91,434.26c.67,1.28,1.34,2.57,1.93,3.84.38.88.81,1.7,1.14,2.61s.7,1.77,1,2.64c.6,1.7,1.23,3.46,1.77,5.13.39,1.17.74,2.28,1.09,3.41-.72-1.23-2.19-3.61-2.33-3.8-2.27-2.89-8.34-7.14-12.2-5.72a4.87,4.87,0,0,0-2.49,6.8c1.28,2.61,4.56,4,7.25,4.55,3,.58,9.23-.88,10-1.07.58,1.86,1.12,3.68,1.61,5.4s.92,3.31,1.33,4.86h2.65c-.5-1.74-1-3.59-1.65-5.56s-1.23-3.9-1.93-6a52.84,52.84,0,0,0,5.32-3.21c2.33,2,8,4.14,8.7,4.4-.55,1.87-1.09,3.69-1.64,5.39s-1.09,3.38-1.61,4.93h2.67c.42-1.34.84-2.74,1.27-4.22.56-1.89,1.12-3.93,1.68-6,.78.08,7.21.7,10.07-.26,2.6-.88,5.67-2.72,6.58-5.48a4.86,4.86,0,0,0-3.36-6.41c-4-.89-9.47,4.12-11.33,7.29-.11.18-1.08,2.34-1.67,3.71.23-.86.45-1.69.67-2.57.44-1.75.83-3.51,1.26-5.41.17-.92.35-1.85.53-2.79s.28-1.93.43-2.9c.3-2.27.49-4.59.63-6.92,1.53.38,7,1.67,9.71,1.19s6-1.82,7.33-4.41a4.85,4.85,0,0,0-2.35-6.84c-3.83-1.5-10,2.63-12.31,5.48-.14.18-1.58,2.4-2.34,3.64.07-1.4.15-2.8.18-4.22.08-4.11,0-8.27,0-12.42,0-1.27,0-2.54,0-3.8.54.14,7,1.81,10,1.27,2.7-.47,6-1.82,7.33-4.41a4.86,4.86,0,0,0-2.36-6.84c-3.83-1.5-10,2.63-12.3,5.48-.18.21-2.24,3.42-2.72,4.26,0-2.79,0-5.57.17-8.31A85.45,85.45,0,0,1,126,389.94c.25.07,7,1.84,10.1,1.3,2.7-.48,6-1.83,7.33-4.41a4.86,4.86,0,0,0-2.35-6.85c-3.83-1.5-10,2.64-12.31,5.48-.18.22-2.39,3.68-2.75,4.33,0-.21.06-.43.1-.64a62.57,62.57,0,0,1,3.21-10.66c.74-1.92,1.56-3.71,2.39-5.44,1.22.46,6.83,2.5,9.68,2.32s6.17-1.16,7.77-3.58a4.87,4.87,0,0,0-1.59-7.07c-3.64-1.9-10.21,1.53-12.83,4.1-.14.14-1.43,1.72-2.35,2.89.38-.77.77-1.58,1.15-2.31,1.45-2.75,2.94-5.19,4.28-7.33.77-1.21,1.49-2.3,2.17-3.3,1.43-.17,7.2-.95,9.61-2.4s4.94-3.88,5.25-6.76a4.87,4.87,0,0,0-4.67-5.54c-4.11,0-8.36,6.06-9.5,9.55-.1.3-1.09,5.2-1,5.19h.09c-.68.95-1.4,2-2.16,3.12-1.39,2.12-2.93,4.53-4.44,7.26a86.78,86.78,0,0,0-4.45,9.05A63.92,63.92,0,0,0,125.21,389s0,.09,0,.13c-.1-1.2-.51-4.54-.57-4.8-.84-3.57-4.58-10-8.67-10.3a4.87,4.87,0,0,0-5.11,5.13c.06,2.91,2.45,5.57,4.67,7.17,2.51,1.81,9.08,3.13,9.61,3.24a85.14,85.14,0,0,0-1.54,11.39c-.16,2.22-.26,4.47-.32,6.73-.13-1-.24-2-.27-2.09-.85-3.57-4.58-10-8.68-10.3a4.87,4.87,0,0,0-5.11,5.13c.06,2.91,2.45,5.57,4.67,7.17s7.84,2.87,9.32,3.18c0,.86,0,1.73,0,2.6-.07,4.15-.11,8.3-.28,12.36-.06,1.43-.17,2.84-.28,4.25-.11-.92-.21-1.69-.24-1.81-.84-3.57-4.58-10-8.67-10.3a4.87,4.87,0,0,0-5.11,5.13c.06,2.91,2.45,5.57,4.67,7.17s7.3,2.75,9,3.12c-.15,1.44-.3,2.89-.51,4.28-.16.94-.26,1.86-.48,2.8s-.39,1.86-.59,2.78c-.44,1.75-.88,3.56-1.35,5.26-.32,1.19-.64,2.31-1,3.44.08-1.43.17-4.22.15-4.45a19,19,0,0,0-3.47-8.88,6.18,6.18,0,0,0-.18-1.06,4.86,4.86,0,0,0-6.34-3.49c-3.85,1.46-5.63,8.66-5.44,12.32,0,.22.4,2.55.67,4-.29-.84-.56-1.66-.87-2.52-.6-1.7-1.24-3.39-1.93-5.2l-1.1-2.62c-.35-.88-.83-1.77-1.24-2.66-1-2.06-2.12-4.09-3.29-6.12,1.49-.52,6.76-2.47,8.76-4.36s4-4.84,3.68-7.72a4.86,4.86,0,0,0-5.74-4.41c-4,.86-6.88,7.7-7.24,11.36,0,.22,0,2.87,0,4.33-.71-1.21-1.41-2.42-2.18-3.63-2.19-3.47-4.53-6.91-6.84-10.36-.71-1.05-1.4-2.11-2.1-3.17.53-.18,6.85-2.35,9.09-4.48,2-1.88,4-4.84,3.68-7.72a4.87,4.87,0,0,0-5.74-4.41c-4,.86-6.88,7.71-7.24,11.36,0,.28,0,4.09.08,5.06-1.53-2.33-3-4.67-4.44-7a84.74,84.74,0,0,1-5.06-9.89c.25-.08,6.85-2.32,9.14-4.49,2-1.89,4-4.84,3.68-7.73a4.86,4.86,0,0,0-5.74-4.41c-4,.87-6.87,7.71-7.24,11.36,0,.29,0,4.39.09,5.14-.08-.2-.19-.4-.27-.6a63.12,63.12,0,0,1-3.2-10.66c-.44-2-.75-3.95-1-5.85,1.28-.29,7.07-1.69,9.35-3.41s4.51-4.37,4.51-7.28a4.86,4.86,0,0,0-5.22-5c-4.09.42-7.68,6.91-8.44,10.5,0,.19-.25,2.22-.37,3.7-.11-.85-.23-1.74-.31-2.56-.32-3.09-.42-5.95-.48-8.47,0-1.44,0-2.74,0-3.95,1.1-.94,5.48-4.77,6.69-7.31s2-6,.65-8.53a4.86,4.86,0,0,0-7-2c-3.44,2.25-3.63,9.66-2.65,13.2.08.31,2,4.94,2,4.89l.06-.06c0,1.17-.07,2.43-.07,3.8,0,2.53.05,5.39.3,8.51a85.89,85.89,0,0,0,1.28,10,64,64,0,0,0,3,10.87.61.61,0,0,1,0,.12c-.74-.94-2.92-3.51-3.11-3.69-2.68-2.51-9.33-5.79-12.93-3.8a4.87,4.87,0,0,0-1.43,7.1c1.66,2.38,5.12,3.28,7.86,3.4,3.09.12,9.3-2.4,9.79-2.6a86.06,86.06,0,0,0,5,10.34c1.09,1.95,2.25,3.88,3.44,5.8-.67-.8-1.28-1.5-1.38-1.59-2.67-2.52-9.32-5.8-12.92-3.81a4.87,4.87,0,0,0-1.43,7.1c1.66,2.38,5.11,3.29,7.85,3.4s8.12-1.93,9.53-2.49l1.38,2.2c2.24,3.5,4.49,7,6.59,10.46.75,1.23,1.43,2.47,2.12,3.7-.6-.71-1.11-1.29-1.19-1.38-2.68-2.51-9.33-5.79-12.93-3.8a4.87,4.87,0,0,0-1.43,7.1c1.66,2.38,5.12,3.29,7.86,3.4S93.23,434.91,94.91,434.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.71,378.29c3.06,1,10.22.06,10.23.06s-2-4.54-2.2-4.81c-1.92-3.13-7.46-8.05-11.46-7.08A4.88,4.88,0,0,0,52,372.93C53,375.67,56.09,377.45,58.71,378.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-91"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 72.25,
    width: 116.05,
    height: 326.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 82.18 287.37 82.18 284.67 73.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 93.05 287.37 93.05 284.67 84.08",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 103.92 287.37 103.92 284.67 94.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 114.8 287.37 114.8 284.67 105.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 125.67 287.37 125.67 284.67 116.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 136.54 287.37 136.54 284.67 127.56",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 147.41 287.37 147.41 284.67 138.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 158.28 287.37 158.28 284.67 149.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 169.15 287.37 169.15 284.67 160.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 180.02 287.37 180.02 284.67 171.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 190.89 287.37 190.89 284.67 181.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 201.77 287.37 201.77 284.67 192.79",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 212.64 287.37 212.64 284.67 203.66",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 223.51 287.37 223.51 284.67 214.53",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 234.38 287.37 234.38 284.67 225.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 245.25 287.37 245.25 284.67 236.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 256.12 287.37 256.12 284.67 247.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 266.99 287.37 266.99 284.67 258.02",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 277.86 287.37 277.86 284.67 268.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 288.74 287.37 288.74 284.67 279.76",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 299.61 287.37 299.61 284.67 290.63",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 310.48 287.37 310.48 284.67 301.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 321.35 287.37 321.35 284.67 312.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 332.22 287.37 332.22 284.67 323.24",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 343.09 287.37 343.09 284.67 334.12",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 353.96 287.37 353.96 284.67 344.99",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 364.83 287.37 364.83 284.67 355.86",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 375.7 287.37 375.7 284.67 366.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "172.18 386.58 287.37 386.58 284.67 377.6",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.35,
    y: 72.25,
    width: 116.05,
    height: 326.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 82.18 412.17 82.18 409.46 73.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 93.05 412.17 93.05 409.46 84.08",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 103.92 412.17 103.92 409.46 94.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 114.8 412.17 114.8 409.46 105.82",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 125.67 412.17 125.67 409.46 116.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 136.54 412.17 136.54 409.46 127.56",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 147.41 412.17 147.41 409.46 138.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 158.28 412.17 158.28 409.46 149.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 169.15 412.17 169.15 409.46 160.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 180.02 412.17 180.02 409.46 171.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 190.89 412.17 190.89 409.46 181.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 201.77 412.17 201.77 409.46 192.79",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 212.64 412.17 212.64 409.46 203.66",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 223.51 412.17 223.51 409.46 214.53",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 234.38 412.17 234.38 409.46 225.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 245.25 412.17 245.25 409.46 236.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 256.12 412.17 256.12 409.46 247.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 266.99 412.17 266.99 409.46 258.02",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 277.86 412.17 277.86 409.46 268.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 288.74 412.17 288.74 409.46 279.76",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 299.61 412.17 299.61 409.46 290.63",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 310.48 412.17 310.48 409.46 301.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 321.35 412.17 321.35 409.46 312.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 332.22 412.17 332.22 409.46 323.24",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 343.09 412.17 343.09 409.46 334.12",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 353.96 412.17 353.96 409.46 344.99",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 364.83 412.17 364.83 409.46 355.86",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 375.7 412.17 375.7 409.46 366.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.97 386.58 412.17 386.58 409.46 377.6",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 437.88,
    y1: 429.79,
    x2: 437.88,
    y2: 71.79,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.17,290.76l1.92,16.33s12.17,9,20.17,17.6,25,20.81,25,20.81,15,.64,17.93,1S510,352.55,510,352.55s1.6,1.6-1.28,2.24a12.24,12.24,0,0,1-5.77-.32s11.21,8.32,12.81,9.6.64,2.88-1.28,2.88-10.25-6.08-10.25-6.08,12.17,9.28,10.25,9.92-5.12.32-5.76-.64-9.93-7-9.93-7,8.65,12.17,9,13.77-3.53,2.24-3.85.32-7.36-9.29-7.36-9.29L495,366l4.8,10.89s-1,1.6-3.2-1a35.62,35.62,0,0,1-3.84-5.45l-5.12-2.88s-9.61-5.12-12.17-6.72-7.36-7.36-7.36-7.36-35.54-13.77-40.66-17-11.84-10.24-11.84-10.24v-33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.11 303.35 413.95 314.11 415.29 302.68 434.78 294.62 434.11 303.35",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503,354.47l-4.48-2.24s-6.4,4.48-13.44,3.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.24,
    y1: 360.87,
    x2: 499.76,
    y2: 357.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,442.18l3.8-61.55A186.36,186.36,0,0,1,314,318h0l-5-98.63,41.3-12.17s33.61-3.84,35.85-3.2,10.89,3.84,12.17,4.48,24,9.61,27.21,11.21,7.36,28.81,10.25,38.1S446,290.44,446,290.44s-12.17,4.8-16.65,6.4-9.6,3.2-9.6,3.2l2.56,33.3,4.16,17,6.4,96.36",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.73,300s1.92-20.48,1.6-25.61S418.45,253,418.45,253l4.8-17.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,273.79s22.41,1,30.73,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.62,
    y1: 274.75,
    x2: 346.1,
    y2: 305.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.22,
    y1: 280.84,
    x2: 351.54,
    y2: 301.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.28,272.51s1.6,23.05,1.6,27.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.78,359.91V349c-22.41,1.29-38.1-3.84-38.1-3.84l.32,18.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.42,192,355,203.52l-6.48,5.28,28.57,34.34s13.69-30,14.17-31.93,1.68-4.09.48-5.53-4.57-10.8-4.57-10.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.22,202.76c-1.4-3.25-3.07-7.88-3.07-7.88l-17.21-1.61-7.29,4.64a21.51,21.51,0,0,0,14.24,5.73A58.79,58.79,0,0,0,390.22,202.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,161.24s3-4.23,5.24-1.81.6,9.47-1,12.69-6.45,3.83-6.45,3.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.64,125.4s-3.36,33.94-2.94,40.22-2.09,18.85.42,23.88,14.25,10.89,19.27,11.31,21.37-2.09,25.14-5.86,9.22-33.52,10.06-35.2,4.6-23.88,4.6-28.9-13.82-12.57-23.88-14.25-24.71.42-28.49,2.93A9.1,9.1,0,0,0,351.64,125.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.79,154.26s-1.5,7.92.95,9.54,2.86.38,3.44-1,.57-6.1.57-6.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,173.91c0-8.64-5-11.07-5-11.07s3.1,11.07,2.46,18.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.87,167.89c-3.23,2.22-6.65,3.22-12.29,3.22s-11.69-3-11.69-3-4.43-2.42-8.46-2-12.09,4.23-14.71,4.83l-2.14.5c-.41,6.4-1.33,14.34.54,18.09,2.52,5,14.25,10.89,19.27,11.31s21.37-2.09,25.14-5.86c1.45-1.45,3.14-6.73,4.73-12.77,0-1.8.06-3.76.21-5.83.61-8.06,3.22-10.48,3.22-10.48a1.55,1.55,0,0,1,.51-.46c0-.22.09-.42.14-.63C401.9,165.09,400.5,166.08,397.87,167.89Z",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.63,
    y1: 168.9,
    x2: 362.61,
    y2: 179.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,170.31a15,15,0,0,0-3.63,6.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.71,176.94c-1,0-2.14,0-3.34,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,175.34a22.34,22.34,0,0,1-6.11,1.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.05,185.82s-5.85,1.81-7.26,1.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.78,194.89a80,80,0,0,0,7.86-2.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.55,155.31s-10.39-2.73-19.75-.21c0,0-2.13,12.41,2.24,14,3.25,1.19,10.17,1.26,11.88.5s4.11-2,5.78-8.23C367.1,159.91,366.55,155.31,366.55,155.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,155.47a46.7,46.7,0,0,1,21.83,1.74s-1.07,12.29-5.56,13.5c-3.34.9-10.24.39-11.88-.52s-3.92-2.4-5.06-8.7C370.07,160,371,155.47,371,155.47Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.55,
    y1: 155.31,
    x2: 371,
    y2: 155.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.84,
    y1: 159.02,
    x2: 370.27,
    y2: 159.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.83 157.21 403.59 159.75 392.63 158.82 392.83 157.21",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,151.77s5.85-3.83,10.28,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.89,151.17s6.05-2.82,14.31,2.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.31,116.6c-10.05-1.67-24.71.42-28.49,2.93a9.1,9.1,0,0,0-4.18,5.87s-1.24,12.49-2.11,23.72c4.1-2.07,11.68-4.24,24.36-2.59a66.83,66.83,0,0,1,30.06,12c1.24-5,4.24-23.21,4.24-27.7C408.19,125.82,394.37,118.28,384.31,116.6Z",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.74,162.45s4.63-2,8.26.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.32,163.66s5-3.22,8.66.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.43,297.16v26.57s25.93,12.49,41.3,15.37S381,348.7,381,348.7s10.25,2.57,13.77,2.57,17.61-2.89,18.57-3.21,9.6,2.25,13.12,2.25,3.84-2.25,3.84-2.25,9.29,3.85,9.93,2.25-1.28-4.49-1.28-4.49,0-4.16-2.24-5.76-18.89-11.2-18.89-11.2-24.33,6.72-28.49,7.36-14.73-1.92-23.69-5.44-49.31-22.09-49.31-22.09l.64-7.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.48,343.26s6.73-.64,10.25,0,10.56,4.8,10.56,4.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.65,337.18s9,.32,12.16,1.6,13.13,7,13.13,7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.89,333.34s5.12-.32,6.4,0,12.48,5.76,12.48,5.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.64,250.1l5.77,23.69.64,28.49s-11.21,2.57-21.13,1-26.25-8.65-26.25-8.65,21.77-68.51,23.05-70.75,3.84-2.88,6.08-3.84,11.52-2.56,11.52-2.56",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.14,138.15s-.95-9-10.44-6.64-15.17,20.86-25.13,37.94-13.28,29.87-8.06,40.78,10.43,18.49,8.06,24.66-10.43,4.74-10.43,4.74-.95,4.74,6.64,6.16,21.81-5.21,28-19.91,7.58-34.62,5.21-44.58-3.32-21.81,0-29.87S181.71,142.89,183.14,138.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.89,140.05a27.82,27.82,0,0,1,6.63,14.7c.64,4.22-1.42,12.32-.94,15.64s3.79,4.27,3.79,10S241.46,205,239.09,210.23s-17.54,1-17.54,1-7.59,12.33-9.49,20.39-3.79,16.12-3.79,16.12S187.4,224,184.08,221.13s-10-7.58-10-7.58,9-7.59,11.38-16.6-5.69-31.77,1.89-43.63,19-16.12,32.25-19S242.89,140.05,242.89,140.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.68 192.87 216.87 220.01 221.55 211.18 204.68 192.87",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.89,140.05s-10-4.75-15.65,0-1,9.48-1,13.75-7.11,5.69-9.49,6.64-2.84,3.32-5.21,7.58-8.54,4.75-8.54,4.75,2.85,12.32-6.16,18.49-11.38,2.37-13.75-2.37S168,159,177.92,141.94s26.08-20.86,39.36-20.86,25.61,6.64,25.61,6.64,5.21-10,11.38,0,2.37,19.91-1,22.28L250,152.37S246.21,143.84,242.89,140.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,212.47c2.5-1.12,6.11-10,6.11-10s8.61-19.17,8.18-22.12a39.11,39.11,0,0,0-1.53-6c-3.62-.28-10.09-.78-20.76-1.58-19-1.43-31.29-6.64-31.29-6.64s-9.49,4.26-2.85,15.17,25.61,29.88,25.61,29.88S235.58,213.58,238.08,212.47ZM213,186c-1.9,4.74-4.27,6.17-4.27,6.17l-9.48-9s-9.48-10-.47-14.7l18.49,6.16S214.91,181.3,213,186Z",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,178.37a62.31,62.31,0,0,0,17.57,2.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.41,194a28,28,0,0,0,3.87.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.07,189.9a91.68,91.68,0,0,0,11.5,3.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,198.69s5.49,4.39,8.24,5.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,174.66s-6.17-18-13.28-8.53,6.16,21.34,7.59,22.28,5.69-3.79,5.69-3.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.14,166.78c0,1.45-.56,2.64-1.25,2.64s-1.25-1.19-1.25-2.64.56-2.64,1.25-2.64S241.14,165.32,241.14,166.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,159.69s5-4.16,9.72.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.31 304.71 255.17 321.95 305.31 312.25 247.63 334.35 227.14 321.95 228.31 304.71",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.81,448.71s11-92.5,11-96.5-8.5-70.5-3-93.5,21-41,28.5-44.5,8-1,17,7,26.5,31,26.5,31,15.5,26.5,17,40.5,2,28.5,3,32,27.5,126.5,27.5,126.5",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.49,384.25l-7.18,5.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.07,354.41s-21.91,16.14-36.42,26.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.1,
    y1: 373.85,
    x2: 157.48,
    y2: 391.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "223.85 406.21 184.14 407.21 184.14 426.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.48,
    y1: 405.87,
    x2: 230.15,
    y2: 406.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.32,257.89s2.85-14.95-10.68-22.43-27.77,2.85-30.62,7.12a24.33,24.33,0,0,0-3.56,12.82c0,3.21-3.2,2.49-3.91,4.27s2.13,4.63,2.13,4.63-1.06,4.27,0,5.7,8.55-7.12,18.16-7.83,17.8,1.78,20.3,2.13S369.61,264,370.32,257.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,256.13l-1.48,2.47a2.81,2.81,0,0,0,3,1.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51,253.66s1.48-.75,3.21,1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.1,267.51s2.14-8.55,2.14-11-17.09-4.63-29.55-1.07-18.87,14.24-21,14.6-16.73-3.56-21.36,1.42-11,18.52-11,18.52-14.6-2.5-23.86,3.56-14.59,24.56-15.31,26.34-3.91,5.7-3.91,5.7,12.46,3.91,40.58-2.49,43.8-13.53,51.27-18.87,18.87-18.16,22.43-21.72S372.1,267.51,372.1,267.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.9,282.21c-.63,1.05-1.13,1.93-1.42,2.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.68,270s-2.54,3.86-5,7.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.85,
    y1: 270.51,
    x2: 311.32,
    y2: 276.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.35,299.47s7.38-9.48,11.06-11.06,10.53-1.58,10.53-1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.81,303.71l17.5,18.5s27-2,43.5-5,42.5-10.5,42.5-10.5l1-17s5-7,6-10,1.5-10.5,4.5-10.5,3,6,2.5,10a28.32,28.32,0,0,1-3,8.5s13.5-4,16-5.5,13-14,16.5-18,5-2,2.5,3a75.4,75.4,0,0,0-6.5,18c-1.5,7-20,18.5-25.5,25s-30.5,16.5-41.5,23-42.5,18-50,20a68.56,68.56,0,0,1-16,2.5c-2.5,0-40.5-40.5-40.5-40.5l25.5-13.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.63 306.15 206.53 326.44 197.44 318.04 222.63 306.15",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.39,274.63s-6.76,10.32-7.12,12.1-5.34,6.77-6.41,7.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.31,236.21s-8.5,9.5-8.5,21.5,14,77.5,14,77.5,41-20,47.5-23.5a46.26,46.26,0,0,0,10-7s-18.5-47-26.5-60-22-17-22-17",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.31,
    y1: 318.71,
    x2: 187.81,
    y2: 277.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.31,
    y1: 262.21,
    x2: 186.31,
    y2: 273.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685,251.14a16.28,16.28,0,0,0-13.26-6.85h-9.82v11h9.82a5.25,5.25,0,0,1,4.95,7L605.43,463.65h12L687,265.93A16.28,16.28,0,0,0,685,251.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.17,463.45s76.14-209.24,75.14-214.24-4.5-10.5-9-11c-2.41-.27-46.16,1.68-86.6,2.76-35.21.94-67.84.78-69.11,3.32-2.72,5.44-79.79,143.92-79.79,143.92l-39,73.5",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591,463.45s72.83-205.24,78.33-214.74-1-10.5-1-10.5l-154,3.5s-4.5,1.5-6.5,4.5-111.5,211-111.5,211",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,445.87s-10,8.73-18.32,12.21-18.31,5.67-22.67,4.8-11.78-5.67-11.78-5.67Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.27,233s-10.11-1.55-8.95-8.16,27.61-18.67,38.89-19.06,32.66,16.33,38.11,27.61,5.44,29.55-1.56,39.66-10.5,9.34-10.11,17.11,7.78,10.5,11.67,16.72,2.72,17.5,2.72,19.45-51.33,3.5-53.66,3.5,7.77-17.11,10.11-28-6.61-19.06-9.34-28.39,2.34-15.55-1.55-29.16S496.27,233,496.27,233Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.05,297.45c2.54,3.35,4.43,5.55,4.43,5.55",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.82,253.23S539,271.9,544.1,282a94.37,94.37,0,0,0,7.51,12.13",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.13,282.4a18.64,18.64,0,0,1,2.41,8.78",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.4,218.52s16.79-6.08,23.16,3.18,2.9,17.08-.29,35c-1.95,11,2,17.12,5.31,22.87",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,253.76c-2,10.49-5.84,19.26-4.26,24.4",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.22,215.33s13,5.79,14.77,22.87a48.56,48.56,0,0,1-.21,10.94",
    style: {
      fill: "none",
      stroke: "#858585",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.31,385.71s8-.5,10,0,2.5,1.5,4,.5a145.44,145.44,0,0,0,11.5-10c3-3,7.5-10,10.5-11.5s5,10,4.5,14.5-16,22.5-17.5,24-27.5-2.5-31.5-7S396.31,385.71,396.31,385.71Z",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.81,396.71s-12.5-15-17.5-25a89.17,89.17,0,0,1-7-21s2.5-13,2-16-13.5-11.5-15.5-12.5-16,14.5-14.5,18.5,14,13,14,13l11.5,50.5S397.31,409.71,404.81,396.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,352.37s1.58-14.72,1.36-17.66-5.37-7.81-6.22-11.25-4.3-4.86-4.58,0,4.29,8.3,4.29,8.3-5.44,9.73-5.15,13.74a13,13,0,0,0,2.29,6.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.62,335.29s-3.17,3.33-3.33,5.23-.47,6.66,1.59,6.34,1.58-5.39,1.9-5.86a28.53,28.53,0,0,1,2.22-2.22s2.22-1.59,2.06-3.81S348.62,335.29,348.62,335.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,328s-4.76,2.7-5.71,4.6-1.91,7.77-1.59,9.2,2.54.95,3.17-.32,2.86-6.34,3.17-7S357.34,327.68,355,328Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.26,323.24s-4.28.31-6.5,2.06-4.92,8.24-4.92,11.26,1.75,2.53,2.86,1.58,3-5.39,3.64-7,2.86-4,3.49-4.13S362.42,326.88,362.26,323.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5,324s-4.58-2.86-6.29-2.86-5.73,10.59-5.73,12.59,3.06.81,4.78-1.48,3.81-5.38,3.81-5.38l1.72,2.86",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.31,346.71s16.5,18.5,24.5,39,23.5,45.5,25.5,49-7.5,5-10.5,6.5-29.5,13.5-38,15.5-24.5,3-24.5,3l-45.5-51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.91,359.53s-7.41,24.85-7.41,35.32-.88,18.75-.44,21.81-11.34,5.23-15.26,10.9-6.11,17-6.11,17-12.64-5.24-21.37-12.22,10.47-19.18,20.5-33.14,24-42.74,24-42.74,6.54-1.3,6.1,3.06",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.29,291.23a24.23,24.23,0,0,1-2.84,16.6c-4.85,8.1-17.3,18.84-9.46,22.78s15.54-7.39,16.35-15.89S499.31,290,497.29,291.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.32,329.84a130.31,130.31,0,0,0-22.55,5.05c-10.11,3.5-24.5,13.22-24.89,22.55s-12.05,24.5-15.55,29.94a60.09,60.09,0,0,1-8.55,10.11s38.1-5.44,61.05,5.45,32.66,14,38.88,17.11,19.83,8.55,30.33,5.44,19.05-.78,26.05-22.94,10.89-32.66,14.39-49.38,4.28-29.56-6.22-34.61-27.61-1.17-36.94,1.94-19.06,5.84-19.06,5.84-31.1,4.27-32.27,4.27A38,38,0,0,1,480.32,329.84Z",
    style: {
      fill: "#845EC2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.4,326.78a.67.67,0,0,0-.06-.28.83.83,0,0,0-.15-.23.72.72,0,0,0-.51-.21v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.4,355.58a.67.67,0,0,0-.06-.28.83.83,0,0,0-.15-.23.72.72,0,0,0-.51-.21v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.19,341.69a.72.72,0,0,0-.51-1.23v1.44A.72.72,0,0,0,576.19,341.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.68,326.78v.72a.72.72,0,0,0,.51-.21.61.61,0,0,0,.15-.23.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.68,355.58v.72a.72.72,0,0,0,.72-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.68,326.06a.71.71,0,0,0-.66.44.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,326.78a.67.67,0,0,0-.06-.28.71.71,0,0,0-1.32,0,.67.67,0,0,0-.06.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.8,319.58a.72.72,0,1,0-.72.72A.72.72,0,0,0,554.8,319.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.2,319.58a.72.72,0,1,0-.72.72A.72.72,0,0,0,569.2,319.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,326.06v.72h.72a.67.67,0,0,0-.06-.28A.71.71,0,0,0,546.88,326.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.68,355.58v-.72a.71.71,0,0,0-.66.44.67.67,0,0,0-.06.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.28,354.86a.71.71,0,0,0-.66.44.67.67,0,0,0-.06.28H562a.67.67,0,0,0-.06-.28A.71.71,0,0,0,561.28,354.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.68,341.9v-1.44a.72.72,0,0,0,0,1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.28,341.9a.72.72,0,1,0-.72-.72A.72.72,0,0,0,561.28,341.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.08,349.1a.72.72,0,1,0-.72-.72A.72.72,0,0,0,554.08,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.48,349.1a.72.72,0,1,0-.72-.72A.72.72,0,0,0,568.48,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.08,334.7a.72.72,0,1,0-.72-.72A.72.72,0,0,0,554.08,334.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.48,334.7a.72.72,0,1,0-.72-.72A.72.72,0,0,0,568.48,334.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.6,355.58a.67.67,0,0,0-.06-.28.71.71,0,0,0-.66-.44v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.6,341.18a.72.72,0,0,0-.72-.72v1.44A.72.72,0,0,0,547.6,341.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.68,327.5v-.72H575a.64.64,0,0,0,.06.28A.71.71,0,0,0,575.68,327.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.62,327.06a.71.71,0,0,0,1.32,0,.64.64,0,0,0,.06-.28h-1.44A.64.64,0,0,0,560.62,327.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,327.5a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28h-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.28,383.66a.72.72,0,0,0-.72.72H562A.72.72,0,0,0,561.28,383.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,370a.71.71,0,0,0,.22.52c.11-.4.23-.8.34-1.21A.72.72,0,0,0,575,370Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.28,369.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,561.28,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.08,376.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,554.08,376.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.2,377.18a.72.72,0,1,0-.72.72A.72.72,0,0,0,569.2,377.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.08,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,554.08,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.48,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,568.48,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,383.66v.72h.72A.72.72,0,0,0,546.88,383.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,369.26v1.44a.72.72,0,0,0,0-1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575,355.58a.72.72,0,0,0,.72.72v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.28,356.3a.72.72,0,0,0,.72-.72h-1.44A.72.72,0,0,0,561.28,356.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,355.58v.72a.72.72,0,0,0,.72-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.05,412.51a.69.69,0,0,0-.43.39.67.67,0,0,0-.06.28h.12C560.8,413,560.93,412.74,561.05,412.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,398.78a.72.72,0,1,0-.72.72A.72.72,0,0,0,562,398.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.8,406a.72.72,0,1,0-.72.72A.72.72,0,0,0,554.8,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.08,390.86a.72.72,0,1,0,.72.72A.72.72,0,0,0,554.08,390.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.76,391.58a.71.71,0,0,0,.61.7c.15-.45.29-.89.43-1.33a.7.7,0,0,0-.32-.09A.72.72,0,0,0,567.76,391.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,412.46v.72h.72a.67.67,0,0,0-.06-.28A.71.71,0,0,0,546.88,412.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.6,398.78a.72.72,0,0,0-.72-.72v1.44A.72.72,0,0,0,547.6,398.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.28,385.1a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28h-1.44a.64.64,0,0,0,.06.28A.71.71,0,0,0,561.28,385.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,385.1a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28h-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.08,419.66a.72.72,0,0,0-.72.72.7.7,0,0,0,.33.59c.36-.23.72-.47,1.08-.74A.72.72,0,0,0,554.08,419.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.56,413.18a.66.66,0,0,0,0,.15l.09-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,413.9a.72.72,0,0,0,.72-.72h-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,326.06a.64.64,0,0,0-.28.06.71.71,0,0,0-.38.38.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.2,326.78a.67.67,0,0,0-.06-.28.71.71,0,0,0-.66-.44.7.7,0,0,0-.66.44.67.67,0,0,0-.06.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,320.3a.72.72,0,0,0,.72-.72.68.68,0,0,0-.08-.31l-1.34.4A.7.7,0,0,0,539.68,320.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,326.11v.67h.72a.67.67,0,0,0-.06-.28.72.72,0,0,0-.58-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,354.86a.64.64,0,0,0-.28.06.71.71,0,0,0-.38.38.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.2,355.58a.67.67,0,0,0-.06-.28.71.71,0,0,0-.66-.44.7.7,0,0,0-.66.44.67.67,0,0,0-.06.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.6,341.85a.82.82,0,0,0,.28,0v-1.44a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66A.73.73,0,0,0,546.6,341.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.48,341.9a.72.72,0,1,0-.72-.72A.72.72,0,0,0,532.48,341.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28,349.1a.72.72,0,1,0-.72-.72A.72.72,0,0,0,525.28,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,349.1a.72.72,0,1,0-.72-.72A.72.72,0,0,0,539.68,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28,334.7a.72.72,0,1,0-.72-.72A.72.72,0,0,0,525.28,334.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,334.7A.72.72,0,1,0,539,334,.72.72,0,0,0,539.68,334.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.8,355.58a.67.67,0,0,0-.06-.28.71.71,0,0,0-.66-.44v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.8,341.18a.72.72,0,0,0-.72-.72v1.44A.72.72,0,0,0,518.8,341.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.16,326.78a.64.64,0,0,0,.06.28.73.73,0,0,0,.38.39.82.82,0,0,0,.28.05v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.82,327.06a.7.7,0,0,0,.66.44.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28h-1.44A.64.64,0,0,0,531.82,327.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,327.5a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28h-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,383.66a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.48,383.66a.72.72,0,0,0-.72.72h1.44A.72.72,0,0,0,532.48,383.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.6,369.32a.71.71,0,0,0-.44.66.73.73,0,0,0,.44.67.82.82,0,0,0,.28.05v-1.44A.64.64,0,0,0,546.6,369.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.48,369.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,532.48,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28,376.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,525.28,376.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,376.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,539.68,376.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,525.28,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,539.68,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.8,384.38a.72.72,0,0,0-.72-.72v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.8,370a.72.72,0,0,0-.72-.72v1.44A.72.72,0,0,0,518.8,370Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.16,355.58a.73.73,0,0,0,.44.67.82.82,0,0,0,.28.05v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.48,356.3a.72.72,0,0,0,.72-.72h-1.44A.72.72,0,0,0,532.48,356.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,356.3a.72.72,0,0,0,.72-.72h-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.88,412.46a.64.64,0,0,0-.28.06.71.71,0,0,0-.38.38.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.48,412.46a.7.7,0,0,0-.66.44.67.67,0,0,0-.06.28h1.44a.67.67,0,0,0-.06-.28A.71.71,0,0,0,532.48,412.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.6,399.45a.82.82,0,0,0,.28.05v-1.44a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66A.73.73,0,0,0,546.6,399.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.48,398.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,532.48,398.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28,405.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,525.28,405.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,405.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,539.68,405.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28,390.86a.72.72,0,1,0,.72.72A.72.72,0,0,0,525.28,390.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.68,390.86a.72.72,0,1,0,.72.72A.72.72,0,0,0,539.68,390.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.8,413.18a.67.67,0,0,0-.06-.28.71.71,0,0,0-.66-.44v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,398.06v1.44a.72.72,0,1,0,0-1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.16,384.38a.64.64,0,0,0,.06.28.76.76,0,0,0,.38.39.82.82,0,0,0,.28.05v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.76,384.38a.64.64,0,0,0,.06.28.7.7,0,0,0,.66.44.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,384.38v.72a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.56,420.38a.72.72,0,1,0,.72-.72A.72.72,0,0,0,524.56,420.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539,420.38a.72.72,0,1,0,.72-.72A.72.72,0,0,0,539,420.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.16,413.18a.73.73,0,0,0,.44.67.82.82,0,0,0,.28,0v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.48,413.9a.72.72,0,0,0,.72-.72h-1.44A.72.72,0,0,0,532.48,413.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,413.9a.72.72,0,0,0,.72-.72h-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,326.11l-.45.12a.68.68,0,0,0-.21.27.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,354.86a.64.64,0,0,0-.28.06.71.71,0,0,0-.38.38.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,354.86a.7.7,0,0,0-.66.44.67.67,0,0,0-.06.28h1.44a.67.67,0,0,0-.06-.28A.71.71,0,0,0,503.68,354.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,341.85a.82.82,0,0,0,.28,0v-1.44a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66A.73.73,0,0,0,517.8,341.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,340.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,503.68,340.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,349.1a.72.72,0,1,0-.72-.72A.72.72,0,0,0,496.48,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.6,348.38a.72.72,0,1,0-.72.72A.72.72,0,0,0,511.6,348.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,334.7a.72.72,0,1,0-.72-.72A.72.72,0,0,0,496.48,334.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.88,333.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,510.88,333.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,355.58a.67.67,0,0,0-.06-.28.83.83,0,0,0-.15-.23.72.72,0,0,0-.51-.21v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.79,340.67a.72.72,0,0,0-.51-.21v1.44a.72.72,0,0,0,.51-1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.36,326.78a.64.64,0,0,0,.06.28.73.73,0,0,0,.38.39.82.82,0,0,0,.28.05v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,383.66a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,383.66a.72.72,0,0,0-.72.72h1.44A.72.72,0,0,0,503.68,383.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,370.65a.82.82,0,0,0,.28.05v-1.44a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66A.73.73,0,0,0,517.8,370.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,369.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,503.68,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,376.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,496.48,376.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.88,377.9a.72.72,0,1,0-.72-.72A.72.72,0,0,0,510.88,377.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,496.48,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.88,363.5a.72.72,0,1,0-.72-.72A.72.72,0,0,0,510.88,363.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.79,383.87a.72.72,0,0,0-.51-.21v.72H490A.72.72,0,0,0,489.79,383.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.79,369.47a.72.72,0,0,0-.51-.21v1.44a.72.72,0,0,0,.51-1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,356.25a.82.82,0,0,0,.28.05v-.72h-.72A.73.73,0,0,0,517.8,356.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,356.3a.72.72,0,0,0,.72-.72H503A.72.72,0,0,0,503.68,356.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.28,355.58v.72a.72.72,0,0,0,.72-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,412.46a.64.64,0,0,0-.28.06.71.71,0,0,0-.38.38.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.34,412.9a.71.71,0,0,0-.66-.44.7.7,0,0,0-.66.44.67.67,0,0,0-.06.28h1.44A.67.67,0,0,0,504.34,412.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,398.12a.71.71,0,0,0-.44.66.73.73,0,0,0,.44.67.82.82,0,0,0,.28.05v-1.44A.64.64,0,0,0,517.8,398.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,398.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,503.68,398.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,406.7a.72.72,0,1,0-.72-.72A.72.72,0,0,0,496.48,406.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.88,405.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,510.88,405.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.76,391.58a.72.72,0,1,0,.72-.72A.72.72,0,0,0,495.76,391.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.88,390.86a.72.72,0,1,0,.72.72A.72.72,0,0,0,510.88,390.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.79,399.29a.72.72,0,0,0-.51-1.23v1.44A.72.72,0,0,0,489.79,399.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.36,384.38a.64.64,0,0,0,.06.28.76.76,0,0,0,.38.39.82.82,0,0,0,.28.05v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,385.1a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28H503a.64.64,0,0,0,.06.28A.7.7,0,0,0,503.68,385.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.28,384.38v.72a.72.72,0,0,0,.51-.21.61.61,0,0,0,.15-.23.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.6,420.38a.72.72,0,1,0-1.44,0,.74.74,0,0,0,.16.44l.59.27A.72.72,0,0,0,511.6,420.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.08,413.18h-.72a.73.73,0,0,0,.44.67.82.82,0,0,0,.28,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.68,413.9a.72.72,0,0,0,.72-.72H503A.72.72,0,0,0,503.68,413.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.28,354.86a.7.7,0,0,0-.66.44.67.67,0,0,0-.06.28h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,354.86a.7.7,0,0,0-.66.44.67.67,0,0,0-.06.28h1.44a.67.67,0,0,0-.06-.28A.71.71,0,0,0,474.88,354.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.56,341.18a.72.72,0,0,0,.72.72v-1.44A.72.72,0,0,0,488.56,341.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,340.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,474.88,340.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.68,349.1a.72.72,0,1,0-.72-.72A.72.72,0,0,0,467.68,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.08,349.1a.72.72,0,1,0-.72-.72A.72.72,0,0,0,482.08,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.68,334.7A.72.72,0,1,0,467,334,.72.72,0,0,0,467.68,334.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.08,334.7a.72.72,0,1,0-.72-.72A.72.72,0,0,0,482.08,334.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.2,355.58a.67.67,0,0,0-.06-.28.71.71,0,0,0-.66-.44v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.2,341.18a.72.72,0,0,0-.72-.72v1.44A.72.72,0,0,0,461.2,341.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.28,383.66a.72.72,0,0,0-.72.72h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,383.66a.72.72,0,0,0-.72.72h1.44A.72.72,0,0,0,474.88,383.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.56,370a.72.72,0,0,0,.72.72v-1.44A.72.72,0,0,0,488.56,370Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,369.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,474.88,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.68,376.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,467.68,376.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.8,377.18a.72.72,0,1,0-.72.72A.72.72,0,0,0,482.8,377.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.68,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,467.68,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.08,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,482.08,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.2,384.38a.72.72,0,0,0-.72-.72v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.48,369.26v1.44a.72.72,0,1,0,0-1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.56,355.58a.72.72,0,0,0,.72.72v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,356.3a.72.72,0,0,0,.72-.72h-1.44A.72.72,0,0,0,474.88,356.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.48,356.3a.72.72,0,0,0,.72-.72h-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.28,399.5v-1.44a.72.72,0,0,0,0,1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.88,399.5a.72.72,0,1,0-.72-.72A.72.72,0,0,0,474.88,399.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.08,405.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,482.08,405.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,391.58a.72.72,0,1,0,.72-.72A.72.72,0,0,0,467,391.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.08,390.86a.72.72,0,1,0,.72.72A.72.72,0,0,0,482.08,390.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.2,398.78a.72.72,0,0,0-.72-.72v1.44A.72.72,0,0,0,461.2,398.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.56,384.38a.64.64,0,0,0,.06.28.7.7,0,0,0,.66.44v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.16,384.38a.64.64,0,0,0,.06.28.7.7,0,0,0,.66.44.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.48,384.38v.72a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.48,355.58v-.72a.64.64,0,0,0-.28.06.71.71,0,0,0-.38.38.67.67,0,0,0-.06.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.8,355.58a.67.67,0,0,0-.06-.28.71.71,0,0,0-.66-.44.73.73,0,0,0-.67.44.87.87,0,0,0-.05.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.2,341.85a.82.82,0,0,0,.28,0v-1.44a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66A.73.73,0,0,0,460.2,341.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.08,341.9a.71.71,0,0,0,.32-1.35c-.35.22-.69.45-1,.68A.71.71,0,0,0,446.08,341.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.6,348.38a.72.72,0,1,0-.72.72A.72.72,0,0,0,439.6,348.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,348.38a.72.72,0,1,0-.72.72A.72.72,0,0,0,454,348.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.48,383.66a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.08,383.66a.72.72,0,0,0-.72.72h1.44A.72.72,0,0,0,446.08,383.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.2,369.32a.71.71,0,0,0-.44.66.73.73,0,0,0,.44.67.82.82,0,0,0,.28.05v-1.44A.64.64,0,0,0,460.2,369.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.08,369.26a.72.72,0,1,0,.72.72A.72.72,0,0,0,446.08,369.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.88,377.9a.72.72,0,1,0-.72-.72A.72.72,0,0,0,438.88,377.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.28,376.46a.72.72,0,1,0,.72.72A.72.72,0,0,0,453.28,376.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,362.78a.72.72,0,1,0,.72-.72A.72.72,0,0,0,438.16,362.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.28,362.06a.72.72,0,1,0,.72.72A.72.72,0,0,0,453.28,362.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,384.38a.72.72,0,0,0-.72-.72v.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68,369.26v1.44a.72.72,0,1,0,0-1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.76,355.58a.73.73,0,0,0,.44.67.82.82,0,0,0,.28.05v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.08,356.3a.72.72,0,0,0,.72-.72h-1.44A.72.72,0,0,0,446.08,356.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.48,398.06a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66.73.73,0,0,0,.44.67.82.82,0,0,0,.28.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,391.58a.72.72,0,1,0,.72-.72A.72.72,0,0,0,438.16,391.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.56,391.58a.72.72,0,1,0,.72-.72A.72.72,0,0,0,452.56,391.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.76,384.38a.64.64,0,0,0,.06.28.76.76,0,0,0,.38.39.82.82,0,0,0,.28.05v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.36,384.38a.82.82,0,0,0,.05.28.73.73,0,0,0,.67.44.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68,384.38v.72a.71.71,0,0,0,.66-.44.64.64,0,0,0,.06-.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68,383.66a.64.64,0,0,0-.28.06.71.71,0,0,0-.44.66h.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.4,369.32a.71.71,0,0,0-.44.66.73.73,0,0,0,.44.67.82.82,0,0,0,.28.05v-1.44A.64.64,0,0,0,431.4,369.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.48,377.9a.72.72,0,0,0,.72-.72.7.7,0,0,0-.56-.68l-.72,1.12A.7.7,0,0,0,424.48,377.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.76,391.58a.72.72,0,1,0,.72-.72A.72.72,0,0,0,423.76,391.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,384.38a.7.7,0,0,0,.72.72v-.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.81,464.21s-3-25.5,3.5-32.5,17.5,4,31.5,8,41.5,1.5,54.5,1.5,39.5-2,39.5-2,30.5-8.5,34-10.5,19.5-16,32.5-20,31.5-1,35.5-2,22.5-14.5,32-17.5,78,10.5,78,10.5,3-3.5,12.5-6,19-2.5,44.5-2.5,43,12,70.5,28,39.5,42,39.5,42l-1,3",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.81,399.71s65.5,15,98,37.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.31,407.21s57.5,19,78,38.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.81,410.71s-28,10-52.5,19.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.14,432.91a67.43,67.43,0,0,0,8.17-2.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.31,436.71s29-7,53.5-2.5c14.47,2.66,28.77,1.48,38.87-.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.81,399.71s0,22-6,34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.8,432.23c-.11,2.37-.27,4.87-.49,7.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.31,402.21s1.95,9.12,1.66,25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.6,223.29s-11.28,6.61-14.78,10.89-4.27,10.89-6.22,16.33-9.72,9.33-10.89,10.5-.77,3.5,1.17,5.05a69,69,0,0,0,5.83,3.89s-1.16,12.06-.39,17.5.39,7.39,3.5,8.17,12.06-.39,12.06-.39,2.72,5.83,2.72,15.55-1.94,11.28-5.44,14-12.84,5.06-12.84,5.06-3.88,9.72,10.11,8.55S518.82,326,518.82,326s12.83-24.89,12-33.06-6.22-15.55-12-24.49.39-17.11-3.5-29.55S505.6,223.29,505.6,223.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.65,274.45a32.15,32.15,0,0,1,.79,16.77c-2,9.58-13.57,12.38-14.77,25.16s12,10,18,6,7.59-8,7.59-8-16,3.2-14.78-.8c2-6.54,5.19,0,9.59-14.77s-.8-23.56-.8-23.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.27,255.18c0,1.71-.61,3.11-1.36,3.11s-1.36-1.4-1.36-3.11.6-3.11,1.36-3.11S496.27,253.46,496.27,255.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.38,246.62s6.22-2.72,9.72,3.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.21,275s7,.39,11.67-1.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.88,275.79s1.55,2.33,0,3.5-5.84,1.94-5.84,1.94.78,3.5-3.89,6.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.26,339.17s-7.38,19.83-15.16,28-16.72,18.67-17.89,30.33,5.06,16.73,5.06,16.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.93,392.44s5.06-9.72,20.22-9.72,19.83,4.66,24.5,4.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.1,367.16s14.39-6.22,24.11-14.38,13.22-13.22,13.22-13.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.65,399.05s21,7.39,22.94,15.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.53,392.93s-40.89-15.51-61.93-27.42-32.37-17.94-40.32-20-16,.68-18.27,1.81-3.22,2.87.34,2.36,9.7.23,10.88.06,4.74,2.15,4.74,2.15-12.73,1.12-15.32,3-4.18,4.51-3.21,5,2.53-.21,3.37-.63a10,10,0,0,1,3.76-1.14c1.35-.05,10-.68,10-.68l.59-.08s-8.17,3-10.53,4.37-3.87,3.57-3.07,3.9,4.44-.63,6-1.31a28.74,28.74,0,0,1,6.88-1.43c1.36,0,6-.25,6-.25a24.36,24.36,0,0,0-5.79,2.78c-2.89,1.93-5.82,2.49-5.65,3.68s1.45,1.75,4.58.4a75.56,75.56,0,0,1,9.6-3.48c1.19-.17,6.19,0,6.19,0s4.35,4.05,8.78,4.48,13,1.6,13,1.6,30.23,35.35,37.09,40.11,17.44,13.34,27.6,13.7,19.07-3.77,19.24-15.26S518.53,392.93,518.53,392.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-91"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 683.88,
    y1: 463.79,
    x2: 700.88,
    y2: 463.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.88,
    y1: 463.79,
    x2: 673.88,
    y2: 463.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorRegister);
export default __webpack_public_path__ + "static/media/Doctor_register.f40f33a0ca56f7e654e715c225ee4845.svg";
export { ForwardRef as ReactComponent };